import { PaymentMethodTypes } from '@webapp/models/enums'
import { type CreateExternalPaymentMethodPayload } from '@webapp/platform/banking/data-access/types/CreatePaymentMethodPayload'
import { type ExternalPaymentMethodFormSchema } from '@webapp/platform/banking/features/create-external-payment-method/views/ExternalPaymentMethodForm/ExternalPaymentMethodForm'

export class FormatExternalPaymentMethodFormForSubmissionUseCase {
  execute = (
    vendorId: number,
    paymentMethodData: ExternalPaymentMethodFormSchema
  ): CreateExternalPaymentMethodPayload => {
    const payload: CreateExternalPaymentMethodPayload = {
      name: paymentMethodData.name,
      currency: paymentMethodData.currency?.id,
      vendor: vendorId,
      type: PaymentMethodTypes.OTHER,
      data: {
        description: paymentMethodData.description,
      },
    }
    return payload
  }
}
